<template>
  <div notice>
    <div class="wrapper">
      <top-visual type="notice">
        <h2>NOTICE</h2>
        <h3>가인패드에서 알려드리는 <br class="hidden-lg-up">공지사항입니다</h3>
      </top-visual>
      <div v-if="detailData" class="inner-wrap">
        <div class="ttl">
          <p><span v-if="detailData.FIXED === 1">공지</span>{{ detailData.TITLE }}</p>
          <p class="date">{{ detailData.REG_DTT }}</p>
        </div>
        <div class="detail" v-html="contParse(detailData.CONT)"></div>
        <div class="btn-wrap">
          <router-link to="/notice" class="btn-list">목 록</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";
  [notice] { .rel; overflow:hidden; }
  .inner-wrap { padding:25px 25px 0; }
  .ttl { .border-t(#323841,2px); .border-b(#bababa); padding:15px 0;
    p:first-child { .fs(1.25rem); .medium;
      span { .ib; .vam; height:24px; line-height:24px; .border(#ccc); border-radius:12px; color:#f97d8d; margin-right:12px; padding:0 12px;}
    }
    p.date { margin-top:15px; .tr; }
  }
  .detail { padding:25px 0; .border-b(#bababa); }
  .btn-list { .block; margin:15px 0; .wh(95px,35px); color:#fff; background:#f85c70; .tc; line-height:35px; .m-hc; }

  @media (min-width: @screen-lg-min) {
    [notice] { padding-bottom:200px; }
    .inner-wrap { margin:140px auto 0; padding:0 60px; max-width:1200px; .border-box; }
    .ttl { .border-t(#323841,2px); .border-b(#bababa); padding:20px 25px;
      p:first-child { .fs(1.25rem); .medium; .ib;
        span { .fs(15px); height:28px; line-height:28px; .border(#ccc); border-radius:14px; color:#f97d8d; margin-right:15px; padding:0 15px; }
      }
      p.date { margin:0; .fr; line-height:30px; }
    }
    .detail { padding:65px 25px; }
    .btn-wrap { .tr;
      .btn-list { .ib; margin:20px 0; .wh(160px,50px); .fsl(18px,50px); }
    }
  }

</style>

<script>
import axios from 'axios';
import handler from '../util/ErrorHandler';
import TopVisual from '../components/TopVisual.vue';
import { contParse } from '../util';


export default {
  name: 'NoticeDetail',
  components: { TopVisual },
  data() {
    return {
      detailData: null,
    };
  },
  created() {
    axios.get('/api/board/detail', { params: { SQ: this.$route.params.detail, TYPE: 'NOTICE' } })
      .then(({ data }) => {
        this.detailData = data.detail;
      })
      .catch(handler());
  },
  methods: {
    contParse(org) {
      return contParse(org);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/NoticeDetail.vue